exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\r\n  margin: 0;\r\n}\r\n\r\n\r\n#custom-search-input{\r\n  border: solid 1px #E4E4E4;\r\n  border-radius: 0.25rem;\r\n  background-color: #fff;\r\n  padding: 0;\r\n  margin-left: 15px;\r\n  margin-right: 15px;\r\n}\r\n\r\n#custom-search-input input{\r\n  border: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n#custom-search-input button{\r\n  margin: 2px 0 0 0;\r\n  background: none;\r\n  box-shadow: none;\r\n  border: 0;\r\n  color: #666666;\r\n  padding: 0 8px 0 10px;\r\n  border-left: solid 1px #ccc;\r\n}\r\n\r\n#custom-search-input button:hover{\r\n  border: 0;\r\n  box-shadow: none;\r\n  border-left: solid 1px #ccc;\r\n}\r\n\r\n#custom-search-input .glyphicon-search{\r\n  font-size: 23px;\r\n}\r\n\r\n.input-group {\r\n  padding: 0;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/Secretary/secretary.component.css
// module id = ./src/app/Secretary/secretary.component.css
// module chunks = 1